/* eslint-disable max-len */
/**
 * Login pages
 */

export const PAGE_LOGIN: string = '/login'
export const PAGE_LOGIN_2FA_METHOD: string = `${PAGE_LOGIN}/2faMethod`
export const PAGE_LOGIN_2FA_PHONE: string = `${PAGE_LOGIN}/2faPhone`
export const PAGE_LOGIN_2FA_CODE: string = `${PAGE_LOGIN}/2faCode`
export const PAGE_LOGIN_FORGOT_PASSWORD: string = `${PAGE_LOGIN}/forgotPassword`
// export const PAGE_LOGIN_RESET_PASSWORD: string = `${PAGE_LOGIN}resetPassword`
export const PAGE_LOGIN_TERMS: string = `${PAGE_LOGIN}/terms`

/**
 * Error pages
 */
export const PAGE_ERROR_401 = '/401'
export const PAGE_ERROR_400 = '/400'
export const PAGE_ERROR_50X = '/500'
export const PAGE_BAD_CONNECTION = '/networkError'
/**
 * Dashboard pages
 */
export const PAGE_DASHBOARD: string = '/'
export const PAGE_ALERTS: string = '/alerts'
export const PAGE_ACTIVITIES: string = '/activities'
/**
 * Chat pages
 */
export const PAGE_CHAT: string = '/chat'
export const PAGE_CHAT_SELECTED: string = `${PAGE_CHAT}/:sid`
/**
 * Tasks pages
 */
export const PAGE_TASKS: string = '/tasks'

/**
 * Patients pages
 */
export const PAGE_PATIENTS: string = '/patients'
export const PAGE_ASSIGN: string = '/assign'
export const PAGE_USERS: string = '/users'
export const PAGE_USER: string = `${PAGE_USERS}/:id`
export const PAGE_USER_COACH_ASSIGNED: string = `${PAGE_USER}/assigned-patients`
export const PAGE_USER_COACH_HISTORY: string = `${PAGE_USER}/history-log`

export const PAGE_PATIENTS_PATIENT_DASHBOARD = `${PAGE_PATIENTS}/:id`
export const PAGE_PATIENTS_PATIENT_CLINIC = `${PAGE_PATIENTS}/:id/clinical`

export const PAGE_PATIENTS_PATIENT_CHARTS = `${PAGE_PATIENTS}/:id/charts`
export const PAGE_PATIENTS_PATIENT_CHARTS_BLOOD_GLUCOSE = `${PAGE_PATIENTS}/:id/charts/bloodGlucose`
export const PAGE_PATIENTS_PATIENT_CHARTS_BLOOD_PRESSURE = `${PAGE_PATIENTS}/:id/charts/bloodPressure`
export const PAGE_PATIENTS_PATIENT_CHARTS_MSK = `${PAGE_PATIENTS}/:id/charts/msk`

export const PAGE_PATIENTS_PATIENT_TIMELINE = `${PAGE_PATIENTS}/:id/timeline`
export const PAGE_PATIENTS_PATIENT_REPORTS = `${PAGE_PATIENTS}/:id/reports`
export const PAGE_PATIENTS_PATIENT_CRM = `${PAGE_PATIENTS}/:id/crm`

/**
 * Coaches pages
 */
export const PAGE_COACHES: string = '/coaches'

/**
 * Admin pages, organization settings pages
 */

export const PAGE_CLINIC_DASHBOARD = '/clinicDashboard'
export const PAGE_ORGANIZATION_SETTINGS = '/orgSettings'
export const PAGE_ORGANIZATION_SETTINGS_GENERAL = `${PAGE_ORGANIZATION_SETTINGS}`
export const PAGE_ORGANIZATION_SETTINGS_USERS = `${PAGE_ORGANIZATION_SETTINGS}/users`
// eslint-disable-next-line max-len
export const PAGE_ORGANIZATION_SETTINGS_EDUCATIONAL_CONTENT = `${PAGE_ORGANIZATION_SETTINGS}/educationalContent`
export const PAGE_ORGANIZATION_SETTINGS_HISTORY_LOG = `${PAGE_ORGANIZATION_SETTINGS}/historyLog`
export const PAGE_ORGANIZATION_SETTINGS_SYSTEM_CONFIG = `${PAGE_ORGANIZATION_SETTINGS}/systemConfig`
// eslint-disable-next-line max-len
export const PAGE_ORGANIZATION_SETTINGS_CONFIGURATION = `${PAGE_ORGANIZATION_SETTINGS}/configuration`
export const PAGE_SEARCH_ORGANIZATION: string = '/searchOrg'

export const PAGE_UPDATE_ORGANIZATION: string = `/updateOrg`
export const PAGE_UPDATE_ORGANIZATION_GENERAL = `${PAGE_UPDATE_ORGANIZATION}/:id`
export const PAGE_UPDATE_ORGANIZATION_HISTORY_LOG = `${PAGE_UPDATE_ORGANIZATION}/:id/historyLog`
export const PAGE_UPDATE_ORGANIZATION_USERS = `${PAGE_UPDATE_ORGANIZATION}/:id/users`
export const PAGE_UPDATE_ORGANIZATION_EDUCATIONAL_CONTENT = `${PAGE_UPDATE_ORGANIZATION}/:id/educationalContent`
export const PAGE_UPDATE_ORGANIZATION_SYSTEM_CONFIG = `${PAGE_UPDATE_ORGANIZATION}/:id/systemConfig`
export const PAGE_UPDATE_ORGANIZATION_CONFIGURATION = `${PAGE_UPDATE_ORGANIZATION}/:id/configuration`
